import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AgreementAction } from './agreement.action';
import { AgreementRequestDto, CustomerAgreementStateType } from '../../modules/user-agreements/agreement';
import { NotificationService, NotificationType } from '../../modules/shared/services';
import { AgreementStore } from './agreement.store';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AgreementFacade {
	constructor(
		private store: Store,
		private notificationService: NotificationService,
		private agreementStore: AgreementStore
	) {}

	walletAgreementStatusChanged = new Subject<{ status: boolean; error: any }>();

	loadAgreements(hardReload = false) {
		this.store.dispatch(AgreementAction.load({ hardReload }));
	}
	setAgreementState(agreementDto: AgreementRequestDto) {
		this.store.dispatch(AgreementAction.updateAgreementStatus({ agreementDto }));
	}
	async toggleAgreementState(agreementId: string) {
		const agreement = await this.agreementStore.getAgreementById(agreementId);
		if (agreement.status == CustomerAgreementStateType.Active) {
			this.store.dispatch(
				AgreementAction.updateAgreementStatus({
					agreementDto: { agreementId, agreementState: CustomerAgreementStateType.Inactive }
				})
			);
		} else {
			this.store.dispatch(
				AgreementAction.updateAgreementStatus({
					agreementDto: { agreementId, agreementState: CustomerAgreementStateType.Active }
				})
			);
		}
	}
	changeWalletAgreementStatus(status: boolean, error?: any) {
		this.walletAgreementStatusChanged.next({ status, error });
	}

	alertForUpdateState(agreementDto: AgreementRequestDto, success: boolean) {
		if (agreementDto.agreementState == CustomerAgreementStateType.Active) {
			success && this.notificationService.alert('توافق‌نامه تایید شد', NotificationType.success);
			!success && this.notificationService.alert('خطا در تایید توافق‌نامه', NotificationType.danger);
		}

		if (agreementDto.agreementState == CustomerAgreementStateType.Inactive) {
			success && this.notificationService.alert('توافق‌نامه رد شد', NotificationType.success);
			!success && this.notificationService.alert('خطا در رد توافق‌نامه', NotificationType.danger);
		}
	}
	//#endregion
}
